import {Pipe, PipeTransform} from "@angular/core"
import { CartitemsService } from '../providers/cartitems.service';

@Pipe({name: 'invoicestatusfilter'})
export class InvoiceStatusPipe implements PipeTransform {

  constructor(private cartitems : CartitemsService){}
  
    transform(items: any[], filter: any): any {
        if (!items || !filter) {
            return items;
        }
        let status = this.cartitems.invoicestatuses[filter];
       // return items.filter(item => status === 0 || item.status === status);
        return items.filter(item => status === 0 || item.status === status || (status === 3 && item.status === 2));
        
    }

    // getStatusNo(status):number {
    //     let selectedStatusNo;
    //     switch(status){
    //         case "All Status":
    //           selectedStatusNo = 0;
    //           break;
    //         case "Paid":
    //           selectedStatusNo = 1;
    //           break;
    //         case "Overdue":
    //           selectedStatusNo = 2;
    //           break;
    //         case "Pending Payment":
    //           selectedStatusNo = 3;
    //           break;
    //         case "Partial":
    //           selectedStatusNo = 4;
    //           break;
    //           case "Todo el estado":
    //           selectedStatusNo = 0;
    //           break;
    //         case "Pagado":
    //           selectedStatusNo = 1;
    //           break;
    //           case "Atrasado":
    //           selectedStatusNo = 2;
    //           break;
    //           case "Pago pendiente":
    //           selectedStatusNo = 3;
    //           break;
    //           case "Parcial":
    //           selectedStatusNo = 4;
    //           break;
            
    //       }

    //       return selectedStatusNo;
    // }
}


// WEBPACK FOOTER //
// ./src/app/providers/invoicestatuspipe.ts